import React, { useEffect, useState } from "react";
import { Space, Tag } from "antd";
import "./styles.css";
import { QuestionSelection } from "./QuestionSelection";
import PermissionOverlay from "../../PermissionedComponents/PermissionOverlay";

const { CheckableTag } = Tag;
export const AllQuestions = ({
  categories,
  handleSelect,
  selectedQuestions,
  handleAnswer,
  selectedAnswers,
}) => {
  const [selectedTags, setSelectedTags] = useState([]);
  const handleChange = (tag, checked) => {
    setSelectedTags(checked ? [tag] : []);
    handleSelect(checked ? [tag] : []);
  };

  return (
    <div className="all-questions">
      <Space size={[0, 8]} wrap style={{ fontWeight: "bold" }}>
        <span style={{ marginRight: 8 }}>Categories:</span>
        {categories.map((tag, index) => (
          <CheckableTag
            key={`${tag}${index}`}
            checked={selectedTags.includes(tag)}
            onChange={(checked) => handleChange(tag, checked)}
          >
            {tag}
          </CheckableTag>
        ))}
      </Space>
      {selectedTags.length ? (

        <PermissionOverlay
          permissionCheck="EditWellnessSurvey"
          tooltipMessage="You don't have permission to modify wellness survey questions"
        >
          <div className="question-text-group">
            {Object.values(selectedQuestions)?.map((questionsArray, index) =>
              questionsArray?.map((question, idx) => (

                <QuestionSelection
                  question={question}
                  handleAnswer={handleAnswer}
                  answer={
                    selectedAnswers.find(
                      ({ questionId }) => question.question_id === questionId
                    ) || {}
                  }
                  index={index} // Pass index to maintain order}
                />

              ))
            )}
          </div>
        </PermissionOverlay>

      ) : (
        <div className="pick-category-text">Please pick a category to get started.</div>
      )}
    </div>
  );
};
